import axios from 'axios'
export default {
  login (user, pass, cb) {
    cb = arguments[arguments.length - 1]
    let bodyFormData = new FormData()
    bodyFormData.set('username', user)
    bodyFormData.set('password', pass)
    axios({
      method: 'post',
      url: '/login',
      data: bodyFormData
    }).then(function (response) {
      if (cb) {
        if (!response.data) {
          cb({ ok: false, message: 'Login not permitted.' })
        } else {
          cb({ ok: true, data: response.data })
        }
      }
    }).catch(function (error) {
      if (!cb) {
        return
      }
      let message = 'Login failed.'
      let status = 0
      let retryAfter = 0
      if (error && error.response) {
        status = error.response.status || 0
        if (error.response.data && error.response.data.error) {
          message = error.response.data.error
        }
        if (error.response.headers && error.response.headers['retry-after']) {
          retryAfter = parseInt(error.response.headers['retry-after'], 10) || 0
        }
      }
      if (status === 429 && retryAfter > 0) {
        const minutes = Math.ceil(retryAfter / 60)
        message = `Too many login attempts. Try again in ${minutes} minute${minutes === 1 ? '' : 's'}.`
      }
      cb({ ok: false, status, message })
    })
  },
  logout (cb) {
    axios({
      method: 'post',
      url: '/logout'
    }).then(function () {
      if (cb) {
        cb(true)
      }
    }).catch(function () {
      if (cb) {
        cb(false)
      }
    })
  }
}
